@if ((kontrakt$ | async); as kontrakt) {
  @if (skogsvardsAtgard) {
    <div class="row"
      (mouseenter)="hoverRow(skogsvardsAtgard.guid, true)"
      (mouseleave)="hoverRow(skogsvardsAtgard.guid, false)">
      <div class="col">
        <div class="skogsvard-header-row">
          <div class="skogsvard-header-cell">
            <rask-skogsvard-badge [skogsvardTyp]="skogsvardsAtgard.atgardstyp"
            [index]="index"></rask-skogsvard-badge>
          </div>
          <div class="skogsvard-header-cell fw-bold">{{skogsvardsAtgard.beteckning}}</div>
          <rask-virkeskop-validation-icon-popover
            [entityGuid]="skogsvardsAtgard.guid">
          </rask-virkeskop-validation-icon-popover>
          <rask-atgard-header-icons></rask-atgard-header-icons>
        </div>
        <div class="skogsvard-header-row">
          @if (hasTradslag) {
            <div class="skogsvard-header-cell">{{tradslagLista}}</div>
          }
          @if (visaPlHa()) {
            <div class="skogsvard-header-cell" [ngClass]="hasTradslag ? 'ms-4' : ''">
            {{getMal()}} {{getMalPlantorEnhet()}}</div>
          }
          @if (visaNettoareal()) {
            <div class="skogsvard-header-cell" [ngClass]="!skogsvardsAtgard.isRojning || hasTradslag ? 'ms-4' : ''">
            {{skogsvardsAtgard.nettoareal | number: '1.2-2': 'sv'}} ha</div>
          }
          <div class="skogsvard-header-cell ms-4">{{skogsvardsAtgard.status}}</div>
          @if (visaSvpStatus()) {
            <div class="skogsvard-header-cell ms-4">{{skogsvardsAtgard.skogsvardStatus}} i SVP</div>
          }
        </div>
      </div>
      @if(hasSvpStatus()) {
      <div class="col-2 pt-2 pe-1">
       <div class="float-end">
          <rask-pillbox [text]="skogsvardsAtgard.beteckning"
            (click)="$event.stopPropagation()"
            [ngbPopover]="aoLinksPopup"
            placement="top-right"
            [autoClose]="'outside'">
            <rask-icon
            icon="far fa-ellipsis-v"></rask-icon>
          </rask-pillbox>
        </div>
        </div>
        }
    </div>
    <ng-template #aoLinksPopup>
        <div style="display: grid">
            @if(hasSvpStatus()) {
                <a href="{{svpLink()}}" target="_blank" class="mt-1">
                AO i SVP
                    <i class="fa-regular fa-up-right-from-square"></i>
                </a>
            }
        </div>
    </ng-template>
  }
}